import { IModel, IAttribute, Collection } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { MongoDbAtlasDataset } from 'app/model/dataset/mongo-db-atlas.dataset';
import { CopySource } from './copysource';
import { ParameterConfig } from 'app/model/pipeline/parameter-config';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { createParameterConfigurationValidator } from 'app/model/adapters/linkedservices/parameter-config.util';


@Metamodel.model({
    name: adfModelTypeMap.mongoDbAtlas.copySourceType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(MongoDbAtlasDataset) }
})
export class MongoDbAtlasCopySource extends CopySource {
    public static readonly MODEL: IModel;
    public static readonly BATCH_SIZE: IAttribute;
    public static readonly FILTER: IAttribute;
    public static readonly PROJECT: IAttribute;
    public static readonly CURSORMETHODS: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'BATCH_SIZE',

        display: stringResources.ModelName_BatchSize
    })
    public batchSize?: number = 100;

    @Metamodel.attribute({
        templatable: true,
        association: 'FILTER',

        display: stringResources.Filter
    })
    public filter?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_CursorMethods,
        collection: Collection.Array,

        constraint: {
            validator: createParameterConfigurationValidator()
        }
    })
    public cursorMethods?: ParameterConfig[] = [];

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
